import { core, getLayoutVars, getGrid, getTitle } from './default';
import { getMetrics, computeCore } from './common';

export default {
  compute: (...args) => computeCore(core, ...args),
  sample: function(sample, template, size) {
    const m = getMetrics(size);

    if (m.cols == 1 && m.rows == 1) {
      return sample;
    }

    if (!sample.vars) {
      sample.vars = {};
    }

    sample.vars.layout = getLayoutVars(size);
    const vars = sample.vars;

    console.log('line layout vars', vars);

    sample.chartName = `Multi-Series Line Chart ${m.cols}x${m.rows}`;
    sample.aspectRatio = `${m.cols}:${m.rows}`;

    if (sample.legend) {
      sample.legend.show = false;
    }

    const series = sample.series;
    sample.series = [];

    const title = sample.title[0];
    sample.title = [];

    const grid = sample.grid[0];
    // let { top = 60, right, bottom, left } = grid;

    sample.grid = [];

    const [xAxis] = sample.xAxis;
    sample.xAxis = [];
    const [yAxis] = sample.yAxis;
    sample.yAxis = [];

    for (let x = 0; x < m.cols; x++) {
      for (let y = 0; y < m.rows; y++) {
        const arg = { x, y, size, type: 'line' };
        let s = series.map((s, i) => ({
          ...s,
          type: 'multiline',
          originalType: 'line',
          name: `${template}-${x + 1}-${y + 1}-${i + 1}`,
          xAxisIndex: sample.xAxis.length,
          yAxisIndex: sample.yAxis.length,
          stack: s ? `${s}-${x + 1}-${y + 1}` : null,
        }));

        sample.series = [...sample.series, ...s];

        sample.title.push({
          ...title,
          ...getTitle(arg, vars, core),
          text: `${x + 1}-${y + 1}`,
        });

        sample.xAxis.push({ ...xAxis, gridIndex: sample.grid.length });
        sample.yAxis.push({ ...yAxis, gridIndex: sample.grid.length });
        sample.grid.push({
          ...grid,
          ...getGrid(arg, vars, core),
        });
      }
    }

    return sample;
  },
};
